import React from "react";
import FormImpls from "../core/FormImpl";

const FormImplsContext = React.createContext(new FormImpls());

export default FormImplsContext;
